<template>
    <div class="container-fluid">
        <Loading v-if="!loaded"></Loading>
        <div v-else>
            <!-- TITLE -->
            <div class="mt-2 tabName">
                <h3>{{ $t('roles_and_permissions') }}</h3>
            </div>
            <div class="mt-md-3" v-if="rolesTab">
                <!-- ROLES TABLE -->
                <!--<router-link :to="{ name: 'role.create' }" class="btn btn-success">{{ $t('create') }}</router-link>-->
                <table class="table table-hover mt-5">
                    <thead>
                        <tr>
                            <th>{{ $t('role') }}</th>
                            <!-- <th>{{ $t('slug') }}</th> -->
                            <th>{{ $t('permissions') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="role in roles" v-bind:key="role.id">
                            <td>{{ $t(`role_${role.slug}`) }}</td>
                            <!-- <td>{{ role.slug }}</td> -->
                            <td style="max-width: 400px">
                                <span
                                    class="badge badge-primary mr-sm-2"
                                    v-for="(permission, index) in role.permissions"
                                    v-bind:key="index"
                                >
                                    {{ $t(`permission_${index}`) }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from '@/views/partial/Loading';
import { mapActions } from 'vuex';
import { getRoles, handleAxiosError } from '@/services/axiosService';

export default {
    components: { Loading },
    data() {
        return {
            loaded: false,
            permissions: [],
            roles: [],
            rolesTab: true
        };
    },
    async created() {
        // get roles
        await this.getRoles();
        this.loaded = true;
    },
    methods: {
        ...mapActions('account', ['logout']),
        // get roles
        async getRoles() {
            try {
                this.roles = await getRoles();
            } catch (error) {
                handleAxiosError(error);
            }
        }
    }
};
</script>
